"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailVerification = void 0;
const ddd_1 = require("../../infrastructure/ddd");
const utils_1 = require("@leavy/utils");
class EmailVerification extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.emailVerified = false;
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.emailVerified) && this.emailVerified);
    }
    toPlain() {
        return { ...this };
    }
}
exports.EmailVerification = EmailVerification;
//# sourceMappingURL=EmailVerification.js.map